import React from "react";
import { formatarPartesMoeda } from "shared/utils/money";

interface PrecoDisplayProps {
  valor: number;
  classeSimbolo?: string;
  classeInteiro?: string;
  classeDecimal?: string;
  classe?: string;
}

export const PrecoDisplay: React.FC<PrecoDisplayProps> = ({
  valor,
  classeSimbolo,
  classeInteiro,
  classeDecimal,
  classe,
}) => {
  const { symbol, integer, decimal } = formatarPartesMoeda(valor);
  return (
    <span className={classe}>
      <span className={classeSimbolo}>{symbol} </span>
      <span className={classeInteiro}>{integer}</span>
      <span className={classeDecimal}>,{decimal}</span>
    </span>
  );
};
